import { z } from "zod";

const SLUG_REGEX = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

export const checkSlugSchema = z
	.object({
		slug: z
			.string()
			.min(3, { message: "Slug must be at least 3 characters" })
			.max(30, { message: "Slug must be at most 30 characters" })
			.regex(SLUG_REGEX, { message: "Slug can only contain lowercase letters, numbers, and hyphens" }),
	})
	.strict();

export type CheckSlugPayload = z.infer<typeof checkSlugSchema>;
